import React from 'react';
import * as Styled from './styled';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import { ReportResult, InProgressStatus } from '../../../models';
import { Icon } from '../../../components';
import { IconName } from '../../../components/icon';

interface ArchiveButtonCellProps {
  cell: TableCell;
}

const createStatusCell = () => ({
  cell,
}: ArchiveButtonCellProps): JSX.Element => {
  const rowData = cell.row.original as ReportResult;

  let iconName = 'inprogress' as IconName,
    tooltip = 'Export is currently processing. This may take several minutes.';
  if (rowData.statusId === InProgressStatus.error) {
    iconName = 'error';
    tooltip = 'There was a problem exporting this report.';
  } else if (rowData.statusId === InProgressStatus.taskComplete) {
    iconName = 'ready';
    tooltip = 'Export is ready to download.';
  }

  return (
    <>
      <Styled.StatusIcon>
        <div className="tooltip">
          <Icon name={iconName} isSpin={iconName === 'inprogress'} />
          <span className="tooltipcontent">{tooltip}</span>
        </div>
      </Styled.StatusIcon>
    </>
  );
};

export default createStatusCell;
